import { render, staticRenderFns } from "./ChannelInfo.view.vue?vue&type=template&id=50831b8c&"
import script from "./ChannelInfo.view.vue?vue&type=script&lang=js&"
export * from "./ChannelInfo.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports